import yuvraj from "./ExTeam/images/yuvraj.jpg";
import samira from "./ExTeam/images/saamira.jpg";
import sree from "./ExTeam/images/sree.jpg";
import mahil from "./ExTeam/images/mahil.jpg";
import rushi from "./ExTeam/images/rushi.jpg";
import sai from "./ExTeam/images/sai.jpg";
import shivay from "./ExTeam/images/shivaay.jpg";
import anudep from "./ExTeam/images/anudeep.jpg";

const gensec2021 = [
  {
    img: samira,
    name: "Saamira Yasmin",
    pos: "General Secretary",
    fb: "https://www.facebook.com/saamira.yasmin",
    linkedin: "https://www.linkedin.com/in/saamira-yasmin-24900b1a1/",
    contact: "#",
    mail: "#",
  },
  {
    img: yuvraj,
    name: "Yuvraj Gupta",
    pos: "General Secretary",
    fb: "https://www.facebook.com/profile.php?id=100007160118952&__tn__=-]K*F",
    insta: "#",
    linkedin: "https://www.linkedin.com/in/yuvraj-gupta-7106b51a1/",
    contact: "#",
    mail: "#",
  },
];

const eventHead2021 = [
  {
    name: "Jnanasree Konda",
    img: sree,
    pos: "Senior Coordinator",
    fb: "https://www.facebook.com/sree.konda.75",
    linkedin: "https://www.linkedin.com/in/jnanasree-konda-535566197/",
    contact: "#",
    mail: "#",
  },

  {
    name: "Mahil Shaik",
    pos: "Senior Coordinator",
    img: mahil,
    fb: "https://www.facebook.com/mahil.shaik",
    linkedin: "https://www.linkedin.com/in/mahil-hussain-shaik-918831196/",
    contact: "#",
    mail: "#",
  },
  {
    img: rushi,
    name: "Rushi Yerawar",
    pos: "Senior Coordinator",
    fb: "https://www.facebook.com/rushi.yerawar.77",
    linkedin: "https://www.linkedin.com/in/rushi-yerawar/",
    contact: "#",
    mail: "#",
  },
];

const designHead2021 = [
  {
    name: "Sai Manohar",
    img: sai,
    pos: "Senior Coordinator",
    fb: "https://www.facebook.com/profile.php?id=100009207196331",
    linkedin: "#",
    contact: "#",
    mail: "#",
  },
  {
    name: "Shivaay Dixit",
    pos: "Web Design Coordinator",
    img: shivay,
    fb: "https://www.facebook.com/iamshivaaydixit",
    insta: "#",
    linkedin: "https://www.linkedin.com/in/shiv-aay/",
    mail: "#",
    contact: "#",
  },
  {
    name: "Anudeep Ramteke",
    img: anudep,
    pos: "Graphics Design Coordinator",
    fb: "https://www.facebook.com/anudeep.ramteke",
    linkedin: "https://www.linkedin.com/in/anudeep-ramteke-b25043196/",
    contact: "#",
    mail: "#",
  },
];

export { gensec2021, designHead2021, eventHead2021};